import { IBaseModel } from "../BaseModel";



export interface IPartCategory extends IBaseModel {
  name: string;

  partOnly: boolean;
  mechOnly: boolean;
  postage: number;
  whCost: number;
  whTime: number;
  disCost: number;
  disTime: number;

  pinnacleName: string;
  frontierName: string;
  tractableName: string;
  /** Shopify Standard Product Taxonomy id, e.g. vp-1-4-1-1. Places the part on PartPro and Shopify. */
  shopifyTaxonomyId: string;
  /** Google Product Taxonomy numeric id (google_product_category) for Merchant Center feeds. */
  googleProductCategoryId: string;
  ucid: string;
  ucidZone: string;
  skuPrefix: string;
  invoiceAccountCode: string;

  /** Admin-owned body scoring weight. Synced to customers and hidden in their category editor. */
  bodyProfiler: number | null;
  /** Admin-owned mechanical scoring weight. Synced to customers and hidden in their category editor. */
  mechanicalProfiler: number | null;

  /** Sent to PartPro trade as hidden, so vendors and buyers there cannot use it as a bid category. */
  excludeFromPartProTrade: boolean;

  side: PartCategorySide;
  position: PartCategoryPosition;
}

export enum PartCategorySide {
  None,
  Left,
  Right
}

export enum PartCategoryPosition {
  None,
  Front,
  Rear
}

/** Result of pushing the category list to PartPro trade (POST /part/categories/push-partpro-trade). */
export interface IPartProTradeSyncSummary {
  created: number;
  updated: number;
  adopted: number;
  hidden: number;
  unchanged: number;
}

export interface ICategorySearchTerm extends IBaseModel {
  include: string | null;
  exclude: string | null;
  categoryId: string | null;
  categoryName: string | null;
  totalParts: number;
  totalPrice: number;
  averagePrice: number;
}